import { ISubmissionAnalyticsPayload } from 'wisestep-api';

import { RTRAnalyticsWidget } from '../../helper';

export interface IPostgreRTRWidgetProp {
  query: ISubmissionAnalyticsPayload;
  title: string;
  widgetName: RTRAnalyticsWidget;
}

export interface IPostgreRTRFields {
  id?: any;
  count?: string | number;
  recruiterName?: string;
  status?: string;
  jobtitle?: string;
  statusWithCount?: Record<string, number>;
}

export interface IPostgreRTRDTO {
  count?: number;
  totalCount?: number;
  resultSet?: IPostgreRTRFields[];
  result?: {
    series?: Record<string, any>[];
    categories?: string[];
  };
}

export const defaultWidgetResponse: IPostgreRTRDTO = {
  count: 0,
  totalCount: 0,
  resultSet: [],
  result: {
    series: [],
    categories: [],
  },
};
